









































import { Component, Vue } from 'vue-property-decorator';
import { RepositoryFactory } from '@/api/RepositoryFactory';

@Component({
  components: {
    ReportsNav: () => import('@/components/ReportsNav.component.vue'),
    ReportsPageHeader: () => import('@/components/ReportsPageHeader.component.vue'),
  },
})
export default class ReportsCustomersView extends Vue {
  private reportsRepository = RepositoryFactory.get('reports');

  public metrics = [
    { label: 'Kunden gesamt', value: '–', description: 'Anzahl Kunden' },
    { label: 'Neue Kunden', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
    { label: 'Projekte pro Kunde', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
    { label: 'Labels pro Kunde', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
    { label: 'Aktive vs inaktive Kunden', value: '–', description: 'Aktive: mind. 1 Projekt; Inaktive: ohne Projekt' },
    { label: 'Kundenwachstum', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
  ];

  public async mounted() {
    try {
      const res = await this.reportsRepository.getCustomerStats();
      const d = res.data;
      if (d.totalCustomers !== undefined) this.metrics[0].value = d.totalCustomers;
      if (d.newCustomers !== undefined) this.metrics[1].value = d.newCustomers;
      if (d.projectsPerCustomer !== undefined) this.metrics[2].value = d.projectsPerCustomer;
      if (d.labelsPerCustomer !== undefined) this.metrics[3].value = d.labelsPerCustomer;
      if (d.activeVsInactive !== undefined) this.metrics[4].value = d.activeVsInactive;
      if (d.customerGrowth !== undefined) this.metrics[5].value = d.customerGrowth;
    } catch {
      // keep defaults
    }
  }
}
